import Pagination from "@/components/share/pagination";
import Update from "../edit";
import Service from "@/utils/api/service";
import Helper from "@/utils/global/func";
import TableLoading from "@/components/share/table-loading";
import NoItem from "@/components/share/table-no-item";
import { mapState } from "vuex";

export default {
  name: "ListAdvertisement",
  data() {
    return {
      isFetching: true,
      isDeleting: false,
      isNoData: false,
      fields: {
        id: "",
        index: "",
      },
      display: {
        modal: {
          delete: {
            index: -1,
            show: false,
          },
          large: false,
        },
      },
      data: {
        advertisements: [],
        detail: {},
        pagination: {
          limit: 10,
          page: 1,
          total: 0,
          totalPage: 0,
        },
      },
      search: {
        type: "",
        status: "",
      },
    };
  },
  components: {
    Pagination,
    Update,
    TableLoading,
    NoItem,
  },
  created() {
    this.setParams();
    this.getAdvertisements();
  },
  watch: {
    "$route.fullPath": function () {
      this.setParams();
      this.getAdvertisements();
    },
  },
  computed: {
    ...mapState(["permissions"]),
  },
  mounted() {},
  methods: {
    setParams() {
      this.search = this.$helper.setParams(
        this.search,
        this.$root.$route.query
      );
    },

    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    getFullImage(path) {
      return process.env.VUE_APP_BASE_URL_IMAGE + path;
    },

    getAdvertisements() {
      this.isFetching = true;
      let query = this.$root.$route.query;
      let setQuery = this.$helper.filterKeyMapping({
        page: query?.page || 1,
        limit: query?.limit || 10,
        ...query,
      });
      let params = this.$helper.queryParam(setQuery);

      Service.getAllAdvertisements(params).then((response) => {
        this.isFetching = false;
        if (response?.statusCode) {
          if (response?.statusCode === "4410") {
            Service.refreshToken().then((response) => {
              if (response === "ok") {
                this.getAdvertisements();
              }
            });
          } else if (response?.statusCode === "403") {
            this.isNoData = true;
            this.data.advertisements = [];
            this.$toasted.show(response?.message);
          } else {
            this.$toasted.show(response?.message);
          }
        } else {
          if (response?.data.length > 0) {
            this.isNoData = false;
            this.data.advertisements = response?.data;
            this.data.pagination = Helper.calculatePagination(response?.meta);
          } else {
            this.data.advertisements = [];
            this.isNoData = true;
            this.resetPagination();
          }
        }
      });
    },

    popupModal(type, index) {
      this.fields.index = index;
      if (type == "delete") {
        this.display.modal.delete.show = true;
      } else {
        this.display.modal.large = true;
        this.data.detail = this.data.advertisements[index];
      }
    },

    deleteAdvertise() {
      this.isDeleting = true;
      let advertisementId = this.data.advertisements[this.fields.index].id;
      Service.deleteAdvertisement(advertisementId).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.deleteAdvertise();
              }
            });
          } else {
            this.isDeleting = false;
            this.$toasted.show(response.message);
          }
        } else {
          this.isDeleting = false;
          this.data.advertisements.splice(this.fields.index, 1);
          this.data.pagination.total -= 1;
          this.$toasted.show("Advertisement has been deleted.");
          this.closeModal();
        }
      });
    },

    async searchAdvertisement() {
      let query = this.$helper.filterKeyMapping({
        limit: 10,
        page: 1,
        ...this.search,
      });
      await this.$router.push({ query }).catch(() => {});
    },

    closeModal() {
      this.display = {
        modal: {
          delete: {
            index: -1,
            show: false,
          },
          large: false,
        },
      };
    },

    resetPagination() {
      this.data.pagination = {
        limit: 10,
        page: 1,
        total: 0,
        totalPage: 0,
      };
    },

    updated(value) {
      this.data.advertisements[this.fields.index] = value;
    },
  },
};
